import React, { useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, IconButton, Typography } from '@mui/material';
import { useComplianceCollapseStyles } from './ComplianceCollapse';
import { getIconStatus } from './helper';
import { RequirementHeaderContainer, RequirementsIconContainer } from './ManageCompliance';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ICondition, IConditionListGroup } from 'app/models/Placement/CredOneCompliance';
import ConditionTable from './ConditionsTable';

/**
 * Component to render a condition group
 */
export const ConditionGroups = ({ conditionGroups }) => {
  return conditionGroups.map((conditionGroupItem: IConditionListGroup, conditionGroupIndex: number) => {
    //@Team: Kevin george : remove use state in callback functions
    const isSingleConditionGroup = conditionGroupItem?.conditions?.length === 1;
    const [expanded, setExpanded] = useState<boolean>(false);
    return (
      <Box
        sx={{
          marginTop: conditionGroupIndex === 0 ? '10px' : 0,
          marginBottom: '12px',
          border: isSingleConditionGroup ? '0' : '1px solid #E7E5E5',
          background: '#F5F5F5',
        }}
        id="condition-group-box"
        key={conditionGroupIndex}
        onClick={() => setExpanded(prevState => !prevState)}
      >
        {conditionGroupItem?.conditions.map((conditionItem: ICondition, conditionIndex: number) =>
          buildConditions(conditionItem, isSingleConditionGroup, conditionIndex, expanded),
        )}
      </Box>
    );
  });
};

/**
 *  Method to create conditions under a condition group
 * @param conditionItem
 * @param isSingleCondition
 * @param index
 */
const buildConditions = (conditionItem: ICondition, isSingleCondition: boolean, index: number, expanded: boolean) => {
  const { classes } = useComplianceCollapseStyles();

  return (
    <Accordion
      className={isSingleCondition ? classes.conditionGroup : classes.conditionGroupBorderHidden}
      elevation={0}
      key={index}
      expanded={expanded}
    >
      <AccordionSummary
        expandIcon={
          <IconButton color="primary" size="small" sx={{ visibility: index === 0 ? 'visible' : 'hidden' }}>
            <ExpandMoreIcon />
          </IconButton>
        }
        aria-controls="panel1a-content"
        id={`condition-accordion-expand-${index}`}
      >
        <RequirementHeaderContainer
          headerContent={<Typography sx={{ fontColor: '#333333', fontWeight: 500 }}>{conditionItem.name}</Typography>}
          icon={getIconStatus(conditionItem.result, conditionItem.isAssetExists)}
        />
        <RequirementsIconContainer sx={{ display: 'flex', justifyContent: 'flex-end' }} isSubAsset={true} />
      </AccordionSummary>
      <AccordionDetails>
        <ConditionTable conditionItem={conditionItem} />
      </AccordionDetails>
    </Accordion>
  );
};
